export const reactScripts = ['react', 'reactDOM'];
